import script from "./ProfileComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileComponent.vue?vue&type=style&index=0&id=461adf29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461adf29"]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon});
